import { render, staticRenderFns } from "./syncMessage.vue?vue&type=template&id=02400e68&scoped=true&lang=pug&"
import script from "./syncMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./syncMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./syncMessage.vue?vue&type=style&index=0&id=02400e68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02400e68",
  null
  
)

export default component.exports